'use client'

import Image from 'next/image'

import { ImageType, VideoType } from '@/lib/models/components/image.types'

import { VideoPlayer } from './VideoPlayer.component'

export const ContentMedia = ({
  contentMedia,
  contentMediaCaption,
  contentMediaThumbnail,
  contentMediaUrl,
}: {
  contentMedia: ImageType | VideoType | null
  contentMediaThumbnail: ImageType | null
  contentMediaCaption?: string
  contentMediaUrl?: string
}) => {
  return (
    <figure>
      {contentMediaUrl && (
        <VideoPlayer
          url={contentMediaUrl}
          thumbnail={contentMediaThumbnail && contentMediaThumbnail.url}
        />
      )}
      {contentMedia && contentMediaThumbnail && !contentMediaUrl && (
        <VideoPlayer
          url={contentMedia.url}
          thumbnail={contentMediaThumbnail && contentMediaThumbnail.url}
        />
      )}
      {contentMedia && !contentMediaThumbnail && (
        <Image
          className={`pt-4 ${contentMediaCaption ? 'pb-4' : 'pb-10'}`}
          src={contentMedia.url}
          width={contentMedia.width}
          height={contentMedia.height}
          alt={contentMedia.alternativeText || 'Content image'}
        />
      )}
      <figcaption
        className={`paragraph-s font-medium text-gray-800 ${
          contentMediaCaption ? 'pb-10 pt-4' : 'hidden'
        }`}
      >
        {contentMediaCaption}
      </figcaption>
    </figure>
  )
}
